import { createBrowserRouter, RouteObject } from 'react-router-dom';

import { Home } from '@pages/home';
import { SafetyTips } from '@pages/safety-tips';
import { Faq } from '@pages/faq';
import { Articles } from '@pages/articles';
import { Profile } from '@pages/profile';
import { About } from '@pages/about';
import { Support } from '@pages/support';
import { UserAgreementPage } from '@pages/user-agreement';
import { UserPrivacyPolicyPage } from '@pages/privacy-policy';
import { NotFound } from '@pages/not-found';

// Moderation
import Moderation from '@components/Moderation/Moderation';
import ModerationLogin from '@components/Moderation/Login';
import ModerationProfile from '@components/Moderation/User/Profile';

// Layout
import { AppLayout } from './layout';
import {CommunityGuidePage} from "@pages/community_guide";
import {HomePage} from "@pages/home_new";

const moderationRoutes: RouteObject[] = [
  {
    path: '',
    element: <ModerationLogin />,
  },
  {
    path: 'user/:category/:id',
    element: <ModerationProfile />,
  },
];

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      // {
      //   path: '/',
      //   element: <Home />,
      // },
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/about',
        element: <About />,
      },
      // {
      //   path: '/safety-tips',
      //   element: <SafetyTips />,
      // },
      // {
      //   path: '/faq',
      //   element: <Faq />,
      // },
      // {
      //   path: '/articles',
      //   element: <Articles />,
      // },
      {
        path: '/support',
        element: <Support />,
      },
      {
        path: '/profile/:id',
        element: <Profile />,
      },
      // {
      //   path: '/moderation',
      //   element: <Moderation />,
      //   children: moderationRoutes,
      // },
      {
        path: '/user-agreement',
        element: <UserAgreementPage />,
      },
      {
        path: '/privacy-policy',
        element: <UserPrivacyPolicyPage />,
      },
      {
        path: '/community-guide',
        element: <CommunityGuidePage />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);
